import { render, staticRenderFns } from "./UserFilesUpload.vue?vue&type=template&id=1003b9a5&scoped=true"
import script from "./UserFilesUpload.vue?vue&type=script&lang=js"
export * from "./UserFilesUpload.vue?vue&type=script&lang=js"
import style0 from "./UserFilesUpload.vue?vue&type=style&index=0&id=1003b9a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1003b9a5",
  null
  
)

export default component.exports